import styled from 'styled-components';

// @todo: theme
export const StyledNotification = styled.li`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;

  background-color: #e8e8e8;
  border-left: 1rem solid #c0c0c0;
  padding: 1rem 2rem;

  &.success {
    border-left-color: #5ec95e;
  }

  &.error {
    border-left-color: #ce3131;
  }

  &.warning {
    border-left-color: #e3914d;
  }
`;
